import { render, staticRenderFns } from "./Occupancy.vue?vue&type=template&id=496c4a46&scoped=true"
import script from "./Occupancy.vue?vue&type=script&setup=true&lang=js"
export * from "./Occupancy.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Occupancy.vue?vue&type=style&index=0&id=496c4a46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c4a46",
  null
  
)

export default component.exports